// extracted by mini-css-extract-plugin
export default {"section":"Project_section__IiY7j","link":"Project_link__eCZuu","parraf":"Project_parraf__WpaKP"};